import { render } from "./NieuwsOverzichtDialog.vue?vue&type=template&id=483978b3&scoped=true"
import script from "./NieuwsOverzichtDialog.vue?vue&type=script&lang=js"
export * from "./NieuwsOverzichtDialog.vue?vue&type=script&lang=js"

import "./NieuwsOverzichtDialog.vue?vue&type=style&index=0&id=483978b3&scoped=true&lang=css"

import exportComponent from "/vercel/path0/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-483978b3"]])

export default __exports__